
export type CursorLiteral =
    '-moz-grab' | '-webkit-grab' | 'alias' | 'all-scroll' | 'auto' | 'cell' | 'col-resize' | 'context-menu' | 'copy' | 'crosshair' |
    'default' | 'e-resize' | 'ew-resize' | 'grab' | 'grabbing' | 'help' | 'move' | 'n-resize' | 'ne-resize' | 'nesw-resize' |
    'no-drop' | 'none' | 'not-allowed' | 'ns-resize' | 'nw-resize' | 'nwse-resize' | 'pointer' | 'progress' | 'row-resize' | 's-resize' |
    'se-resize' | 'sw-resize' | 'text' | 'vertical-text' | 'w-resize' | 'wait' | 'zoom-in' | 'zoom-out';

export type CursorValue = string | CursorLiteral;

const state = {
    custom: new Map<string, [string, number, number]>(),
    current: 'auto',
};

export const Cursor = {

    define(name: string, url: string, offsetX: number, offsetY: number) {
        state.custom.set(name, [url, offsetX, offsetY]);
    },

    set(input?: string | CursorLiteral) {
        input = input || 'auto';
        if (state.current !== input) {
            const def = state.custom.get(input);
            const value = !!def ? `url(${def[0]}) ${def[1] ?? 0} ${def[2] ?? 0}, auto` : input;
            document.body.style.cursor = value;
            state.current = input;
        }
    },

    css(input?: string | CursorLiteral): string {
        input = input || 'auto';
        const def = state.custom.get(input);
        return !!def ? `url(${def[0]}) ${def[1] ?? 0} ${def[2] ?? 0}, auto` : input;
    }
};
